module.exports = __webpack_public_path__ + "img/full0-min.a8454bc6.png";